import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';


export function getCursoOpinionListSuccess(cursoopinion) {
  return {type: types.LOAD_CURSOOPINION_LIST_SUCCESS, cursoopinion};
}



export function getCursoOpinionList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoOpinionApi.getCursoOpinionList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(cursoopinion => {                  
                  dispatch(getCursoOpinionListSuccess(cursoopinion));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getCursoOpinionSuccess(catalogo) {
  return {type: types.LOAD_CURSOOPINION_SUCCESS, catalogo};
}

export function getCursoOpinion(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().CursoOpinionApi.getCursoOpinion(id, token).then(cursoopinion => {   
        dispatch(getCursoOpinionSuccess(cursoopinion));
        return cursoopinion;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(cursoopinion) {
  return {type: types.SAVE_CURSOOPINION_SUCCESS, cursoopinion};
}


export function save(cursoopinion, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CursoOpinionApi.save(cursoopinion, token).then(cursoopinionGuardado => {   
    dispatch(saveSuccess(cursoopinionGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function saveComentarioUsuario(cursoopinion, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CursoOpinionApi.saveComentarioUsuario(cursoopinion, token).then(cursoopinionGuardado => {   
    dispatch(saveSuccess(cursoopinionGuardado));
    return cursoopinionGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getCursoOpinionComboSuccess(datos) {
  return {type: types.GET_CURSOOPINIONS_COMBO_SUCCESS, datos};
}

export function getCursoOpinionCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().CursoOpinionApi.getCursoOpinionCombo(token).then(datos => {   
        
      dispatch(getCursoOpinionComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(cursoopinion) {
  return {type: types.BORRAR_CURSOOPINION_SUCCESS, cursoopinion};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoOpinionApi.borrar(id, token ).then(cursoopinion => {
               
                  dispatch(borrarSuccess(cursoopinion));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(cursoopinion) {
  return {type: types.ACTIVAR_CURSOOPINION_SUCCESS, cursoopinion};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoOpinionApi.activar(id, token).then(cursoopinion => {
               
                  dispatch(activarSuccess(cursoopinion));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_CURSOOPINION, filtro};
}



